// App.js
import React from "react";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";

import Home from "./Home"; 
import Entreprises from "./pages/Entreprises";
import Devis from "./pages/Devis";

function App() {
  return (
    <Router>
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/entreprises" element={<Entreprises />} />
        <Route path="/devis" element={<Devis />} />
      </Routes>
    </Router>
  );
}

export default App;
